import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import { colors } from '../utils/vars'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { mVAL } from '../utils/masks';
import ModalPix from '../components/ModalPix';

const moment = require("moment");
const swal = withReactContent(Swal)

function RegBaixaCtr(props) {
  const [data, setData] = useState({baixa_temporaria: 'N'})
  const [updateType, setUpdateType] = useState(false)
  const [comboPromocoes, setComboPromocoes] = useState([{display: '', value: ''}])
  const [comboFpg, setComboFpg] = useState([{display: '', value: ''}])
  const [comboContas, setComboContas] = useState([{display: '', value: ''}])
  const [enableEdit, setEnableEdit] = useState('N')
  const [showModalPix, setShowModalPix] = useState(false)
  const [modoPix, setModoPix] = useState(false)
  const [comboSimNao, setComboSimNao] = useState([{ value: 'S', display: 'Sim' },{ value: 'N', display: 'Não' }])
  var titulo = ''

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Baixa Ctr', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Baixa Ctr', 'Inclusao'))
      }

      setComboPromocoes(await api.getComboData('promocoes'))
      setComboContas(await api.getComboData('contas'))
      setComboFpg(await api.getComboData('formas_pagamento'))


      if (query.codigo) {
        
        setModoPix(query.pix == 'true')
        setUpdateType(true)
        api.get('/contas_receber?pk_ctrs=' + query.codigo).then(r => {
          if (r.data[0]) {
            let auxValues = [...r.data]
            let d = auxValues
            console.log(r.data)
            d.data_pagamento = new Date().toISOString()
            d.valor = auxValues.reduce((accumulator, currentValue) => accumulator + (Math.round(currentValue.valor * 100) /100), 0) 
            console.log(d.valor)
            // auxValues.valor = Math.round(auxValues.valor * 100) /100
            d.multa = auxValues.reduce((accumulator, currentValue) => accumulator + (Math.round((calculoMulta(currentValue) * 100)) / 100), 0) 
            // auxValues.multa = calculoMulta(r.data[0]).toFixed(2)
            d.juros = auxValues.reduce((accumulator, currentValue) => accumulator + (Math.round((calculoJuros(currentValue) * 100)) / 100), 0) 
            // auxValues.juros = calculoJuros(r.data[0]).toFixed(2)
            d.total = (d.valor + (d.juros) + (d.multa))
            d.total = Math.round(d.total * 100) /100
            d.total = d.total * 100
            d.valor = d.valor*100
            d.fk_cli = auxValues[0].fk_cli
            console.log(d)
      
      

            setData({
              ...auxValues[0],
              ...d,
            })
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function calculoMulta(item) {
    const valorOriginal = parseFloat(item.valor) || 0
    const hoje = new Date();
    const vencimento = new Date(item.data_venc);
    vencimento.setHours(23);
    const diasAtraso = Math.max(0, (Date.parse(hoje.toString()) - Date.parse(vencimento.toString())) / (1000 * 60 * 60 * 24));
    const mesesAtraso = diasAtraso / 30;

    const multa = diasAtraso >= 1 ? valorOriginal * (2 / 100) : 0;
    const juros = valorOriginal * (1 / 100) * mesesAtraso; // Juros SOBRE O ORIGINAL
    const total = valorOriginal + multa + juros;
    console.log(multa)
    return multa
       
  }

  function calculoJuros(item) {
    const valorOriginal = parseFloat(item.valor) || 0
    const hoje = new Date();
    console.log(isNaN(item.data_venc.substr(8,2)))
    const vencimento = new Date(item.data_venc);
    const dia = isNaN(item.data_venc.substr(8,2)) ? vencimento.getDate() : item.data_venc.substr(8,2)
    console.log(dia)
    vencimento.setHours(23);
    vencimento.setDate(dia)
    console.log(vencimento)
    const diasAtraso = Math.max(0, (Date.parse(hoje.toString()) - Date.parse(vencimento.toString())) / (1000 * 60 * 60 * 24));
    const mesesAtraso = diasAtraso / 30;
    console.log(diasAtraso)
    console.log(hoje, vencimento)
    const multa = diasAtraso >= 1 ? valorOriginal * (2 / 100) : 0;
    const juros = valorOriginal * (1 / 100) * mesesAtraso; // Juros SOBRE O ORIGINAL
    const total = valorOriginal + multa + juros;
    console.log(juros)
    return juros
       
  }

  function consistData(data) {
    let required = [
      'valor',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        auxValues.data_pagamento = auxValues.data_pagamento.split('T')[0]
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          try {
            api.post('/contas_receber/baixa', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          } catch {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              text: "O registro não foi adicionado!",
              icon: 'warning',
            })

          }
          
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'valor_promocao' : auxValues[e.target.name] = mVAL(e.target.value);
      break;
      default: auxValues[e.target.name] = e.target.value;
    }
    console.log(auxValues.valor_promocao)
    setData(auxValues);
  };

  useEffect(() => {
    let auxValues = {...data}
    if (data.troco > 0) {
      auxValues.valor_troco = mVAL((auxValues.total - auxValues.troco) * 100)
    } else {
      auxValues.valor_troco = 0
    }

    setData(auxValues)
  }, [data.troco ])

  useEffect(() => {
    let auxValues = {...data}
    if ((auxValues.valor_promocao)) {
      let vPromo = Number(auxValues.valor_promocao.replace('.', '').replace(',','.'))
      console.log(auxValues.valor,  auxValues.multa, auxValues.juros, vPromo, (Number(auxValues.valor) + Number(auxValues.multa) + Number(auxValues.juros) - vPromo))
      auxValues.total = mVAL((Number(auxValues.valor) + Number(auxValues.multa) + Number(auxValues.juros) - vPromo) * 100)
    } 
    console.log(auxValues.valor)
    setData(auxValues)
  }, [data.valor_promocao ])

  // useEffect(() => {
  //   if 
  // }, [])

  async function copiaLink (link) {
    // fallbackCopyTextToClipboard(link)
    try {
      await navigator.clipboard.writeText(link)
    } catch(e) {
      fallbackCopyTextToClipboard(link)
    }
  }

  function verificaPagamentoPix(link, orderId){
    copiaLink(link)
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.post('contas_receber/baixa_pix?order_id=' + orderId).then(r => {
      console.log(r.status)
      if (r.status == 200) {
        swal.fire('Concluído!', 'Pagamento realizado com sucesso.', 'success').then(() => {
          window.history.back()
        })
      } else {
        swal.fire('Erro!', 'Falha no processamento do pagamento.', 'error')
      }
    })
  }

  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Ensure the textarea is not visible but still in the DOM
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);
    
    textArea.focus();
    textArea.select();
  
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }
  
  function pagamentoPix() {
    let auxValues = {...data}
    auxValues.parcelas = String(data.fk_ctr)
    auxValues.total = auxValues.total / 100
    console.log(auxValues)
    api.post('pagarMe/pix?pk_cli='+data.fk_cli, auxValues).then(r=>{
      console.log(r.data)
      swal.fire({
        customClass: {
          container: 'my-swal'
        },
        html: 
          <div>
            <h3>
              Código PIX Gerado:
            </h3>
            <p>
            {r.data.pix_qrcode}
            </p>
            <button className="botao" onClick={() => verificaPagamentoPix(r.data.pix_qrcode, r.data.order_id)}>
              Copiar
            </button>
          </div>,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      // swal.fire("Código PIX Gerado:", r.data.pix_qrcode, 'success').then (res =>{
      //   window.location.href = '/salute/contratos?buscar=true&pk_cto=' + dadosPagamento.pk_cto
      // })
    })
  }

  return (
    <div className="defaultReg">
      <NavBar />
     
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{data ? `Baixa Titulo. `: ''}</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <h4>
          {`Contrato: ${data?.fk_cto}, cliente: ${data?.nomecli}, vencimento: ${moment(data.data_venc).format('DD/MM/YYYY')}`}
          
        </h4>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          <FrDatePicker
            name="data_pagamento"
            id="data_pagamento"
            color="#389492"
            label="Data Pagamento"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.data_pagamento || '').split("T")[0]}
            onChange={handleChange}
          />
          <br/>
          <FrTextInput
            value={mVAL(data.valor) || ''}
            // onChange={handleChange}
            name="valor"
            id="valor"
            color="#389492"
            label="Valor"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
          />
          <FrTextInput
            value={mVAL(data.multa) || ''}
            // onChange={handleChange}
            name="multa"
            id="multa"
            color="#389492"
            label="Multa"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
          />
          <FrTextInput
            value={mVAL(data.juros) || ''}
            // onChange={handleChange}
            name="juros"
            id="juros"
            color="#389492"
            label="Juros"
            variant="outlined"
            size="small"
            required
            readOnly
            style={{ width: 150 }}
          />

          
          <br/>
          

          <FrSelect
            value={data.fk_prm || ''}
            onChange={handleChange}
            name="fk_prm"
            id="fk_prm"
            label='Promoção'
            data={comboPromocoes}
            style={{ width: 300 }}
          />
          <FrTextInput
            value={(data.valor_promocao) || ''}
            onChange={handleChange}
            name="valor_promocao"
            id="valor_promocao"
            color="#389492"
            label="Valor Promoção"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
          />
          <br/>
          <FrTextInput
            value={data.justificativa_promocao || ''}
            onChange={handleChange}
            name="justificativa_promocao"
            id="justificativa_promocao"
            color="#389492"
            label="Justificativa Promoção"
            variant="outlined"
            size="small"
            required
            style={{ width: 500 }}
          />
          <br/>
          <FrSelect
            value={data.fk_fpg || ''}
            onChange={handleChange}
            name="fk_fpg"
            id="fk_fpg"
            label='Forma de Pagamento'
            data={comboFpg}
            style={{ width: 300 }}
          />
          <FrSelect
            value={data.fk_cta || ''}
            onChange={handleChange}
            name="fk_cta"
            id="fk_cta"
            label='Conta'
            data={comboContas}
            style={{ width: 250 }}
          />
          <br/>
          <FrTextInput
            value={mVAL(data.total) || ''}
            // onChange={handleChange}
            name="total"
            id="total"
            color="#389492"
            label="Total"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
          />
          <FrTextInput
            value={data.troco || ''}
            onChange={handleChange}
            name="troco"
            id="troco"
            color="#389492"
            label="Troco Para"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
            disabled={data.fk_fpg != 2}
          />
          <br/>
          <FrTextInput
            value={data.valor_troco || ''}
            onChange={handleChange}
            name="valor_troco"
            id="valor_troco"
            color="#389492"
            label="Valor Troco"
            variant="outlined"
            size="small"
            required
            style={{ width: 150 }}
            disabled={data.fk_fpg != 2}
          />
          <br/>
          <FrSelect
            value={data.baixa_temporaria || ''}
            onChange={handleChange}
            name="baixa_temporaria"
            id="baixa_temporaria"
            label='Baixa Temporária'
            data={comboSimNao}
            style={{ width: 170 }}
            disabled={data.fk_fpg != 2}
          />

        </form>
        <div className="regButtonsDiv">
          {modoPix ? <button onClick={pagamentoPix}>Gerar</button> : <button onClick={handleSubmit}>Salvar</button>}
          
          <button onClick={handleCancel}>Cancelar</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegBaixaCtr;
